import $i18n from '@/locales/i18n';
import React from 'react';
import { createBlockSnippet } from '@/common/manager/setter-snippet';
import { groupColumn } from '@/common/util/block';
import { makeColumnDom } from '@/lowcode/cn-layout-section/components/dom';
import './index.scss';
const { CnButton, CnBalloon } = window.CNUI || {};
// 当前是主端还是辅端 main/ onecode
const endType = window?.getCnLowcodeStoreItem?.('__next_cone_client__');
// 一码多端辅端模式
const oneCodeMode = endType === 'onecode';
/**
 * @description 虚拟布局视图Setter
 */
export default class LayoutSetter extends React.Component {
    sectionNode;
    constructor(props) {
        super(props);
        this.sectionNode = this.props?.prop?.getNode?.();
    }
    changeLayout = ({ currentLine, oldLineDetail2, newLineDetailStr, list, }) => {
        // [6,6]   0行  [{index:0,value:6},{index:1,value:6}]  '4:4:4'
        const newLineDetail = newLineDetailStr.split(':')?.map((item) => +item);
        // 块个数相同，调整块span
        if (newLineDetail.length === oldLineDetail2.length) {
            oldLineDetail2.forEach((item, index) => {
                // 调整块span
                this.adjustBlockSpan(item.index, newLineDetail[index]);
            });
        }
        else if (newLineDetail.length > oldLineDetail2.length) {
            // 块个数增加，新增块
            const addList = newLineDetail.slice(oldLineDetail2.length);
            oldLineDetail2.forEach((item, index) => {
                // 调整块span
                this.adjustBlockSpan(item.index, newLineDetail[index]);
            });
            if (oneCodeMode) {
                const lastBlock = oldLineDetail2[oldLineDetail2.length - 1];
                addList.forEach((item, index) => {
                    // 调整块span
                    this.adjustBlockSpan(lastBlock?.index + index + 1, item);
                });
            }
            else {
                // 调整块span
                this.insertNewBlock(oldLineDetail2[oldLineDetail2.length - 1]?.index, addList);
            }
        }
        else if (newLineDetail.length < oldLineDetail2.length) {
            oldLineDetail2.forEach((item, index) => {
                // 调整块span
                this.adjustBlockSpan(item.index, newLineDetail[index]);
            });
            const removeList = oldLineDetail2.slice(newLineDetail.length);
            const nextList = list[currentLine + 1] || [];
            this.batchSetBlockSpan([...removeList, ...nextList]);
        }
    };
    // 调整某个块的span值
    adjustBlockSpan = (blockIndex, newSpan) => {
        if (typeof blockIndex === 'number' && typeof newSpan === 'number') {
            const children = this.sectionNode?.schema?.children || [];
            const childrenListSchema = Array.isArray(children) ? children : [children];
            const targetNode = childrenListSchema[blockIndex];
            if (targetNode?.id) {
                // @ts-ignore 上游类型定义错误
                this.sectionNode?.document?.getNodeById?.(targetNode?.id)?.setPropValue('span', newSpan);
            }
        }
    };
    insertNewBlock = (blockIndex, addList) => {
        if (typeof blockIndex === 'number' && Array.isArray(addList) && addList.length > 0) {
            const parentNode = this.sectionNode?.getNode()?.parent;
            const cardProps = parentNode?.componentName === 'CnCard' && parentNode?.getPropValue?.('shape') !== 'group'
                ? {
                    shape: 'simple',
                    noPadding: true,
                    noShadow: true,
                }
                : {};
            const toAddChildren = addList.map((item) => {
                const blockSchema = createBlockSnippet({ blockProps: { span: Number(item) }, cardProps });
                return blockSchema;
            });
            const oldSchema = { ...this.sectionNode?.schema };
            const children = this.sectionNode?.schema?.children || [];
            const oldChildren = Array.isArray(children) ? children : [children];
            let targetNode = oldChildren[blockIndex];
            if (blockIndex === -1) {
                targetNode = oldChildren[0];
            }
            if (targetNode?.id) {
                const newChildren = [...oldChildren];
                newChildren.splice(blockIndex + 1, 0, ...toAddChildren);
                oldSchema.children = newChildren;
                // @ts-ignore 上游类型定义错误
                this.sectionNode?.importSchema?.(oldSchema);
            }
        }
    };
    // 删除当前行
    removeBlock = (removeList) => {
        if (Array.isArray(removeList) && removeList.length > 0) {
            const removeList2 = removeList.map((item) => item.index);
            // @ts-ignore ...
            this.sectionNode?.mergeChildren((child, index) => {
                if (removeList2.includes(index)) {
                    return true;
                }
                return false;
            }, () => { });
        }
    };
    // 高亮画布中当前hover的虚拟行
    highLightCurrentLine = (current) => {
        if (Array.isArray(current)) {
            // @ts-ignore 获取iframe中内容
            const doc = document.getElementsByName('SimulatorRenderer')?.[0]?.contentDocument;
            this.resetHighLight();
            const children = this.sectionNode?.schema?.children || [];
            const childrenListSchema = Array.isArray(children) ? children : [children];
            current.forEach((item) => {
                const { index } = item || {};
                const targetNode = childrenListSchema[index];
                if (targetNode?.id) {
                    const targetDom = doc.querySelector(`[componentid="${targetNode?.id}"]`);
                    if (targetDom) {
                        targetDom.style.border = '1px solid #1677ff';
                    }
                }
            });
        }
    };
    // 取消画布中当前高亮的虚拟行
    resetHighLight = () => {
        // @ts-ignore 获取iframe中内容
        const doc = document.getElementsByName('SimulatorRenderer')?.[0]?.contentDocument;
        const all = doc?.getElementsByClassName('cn-layout-block');
        if (all?.length > 0) {
            for (const item of all) {
                if (item) {
                    item.style.border = 'none';
                }
            }
        }
    };
    // 合并行
    batchSetBlockSpan = (totalList) => {
        const newSpan = Math.floor(12 / totalList?.length);
        if (newSpan < 1) {
            return;
        }
        totalList.forEach((item) => {
            // 调整块span
            this.adjustBlockSpan(item.index, newSpan);
        });
    };
    renderMergeButton = (newList, index) => {
        if (index === 0) {
            return null;
        }
        const first = newList[index - 1];
        const second = newList[index];
        if (first?.length + second?.length <= 12) {
            return (<CnButton onClick={() => {
                    this.batchSetBlockSpan([...first, ...second]);
                }} size={'small'}>
          {$i18n.get({
                    id: 'Manual.MergeLines',
                    dm: '合并{pre}, {next}行',
                }, { pre: index, next: index + 1 })}
        </CnButton>);
        }
        return null;
    };
    render() {
        const { value } = this.props || {};
        let newList = [];
        if (value) {
            newList = groupColumn(value?.split?.(':'));
        }
        return (<div className="cn-layout-setter-wrap">
        {newList?.length > 0
                ? newList.map((current, index) => {
                    const item = current.map((temp) => temp.value);
                    let currentValue = item.join(':');
                    if (Array.isArray(item) && item.length === 1) {
                        currentValue = `${item[0]}`;
                    }
                    return (<div onMouseEnter={() => {
                            this.highLightCurrentLine(current);
                        }} onMouseLeave={() => {
                            this.resetHighLight();
                        }} className="cn-layout-setter-item">
                  <div className="cn-layout-setter-item-title">
                    <div className="cn-layout-setter-item-title-left">
                      <span>
                        {$i18n.get({ id: 'Section', dm: '第' })}
                        {index + 1}
                        {$i18n.get({ id: 'Line', dm: '行' })}
                      </span>
                      <div className="cn-layout-setter-item-insert">
                        {this.renderMergeButton(newList, index)}
                        {!oneCodeMode && (<CnBalloon v2 popupStyle={{ minWidth: '312px' }} closable={false} align={'t'} trigger={<CnButton size={'small'}>
                                {index === 0
                                    ? $i18n.get({
                                        id: 'Manual.InsertBefore',
                                        dm: '第{line}行前插入新行',
                                    }, { line: index + 1 })
                                    : $i18n.get({
                                        id: 'Manual.InsertBetween',
                                        dm: '在{pre}, {next}行之间插入行',
                                    }, { pre: index, next: index + 1 })}
                              </CnButton>}>
                            <div className={'cn-layout-setter-item-content'}>
                              {makeColumnDom({
                                value: '',
                                onClick: (newV) => {
                                    this.insertNewBlock(current[0].index === 0 ? -1 : current[0].index - 1, newV.split(':'));
                                },
                            })}
                            </div>
                          </CnBalloon>)}
                      </div>
                    </div>
                    <div className="cn-layout-setter-item-delete">
                      {!oneCodeMode && (<CnButton onClick={() => {
                                this.removeBlock(current);
                            }} size={'small'} warning>
                          {$i18n.get({ id: 'TERM.Delete', dm: '删除' })}
                        </CnButton>)}
                    </div>
                  </div>
                  <div className="cn-layout-setter-item-content">
                    {makeColumnDom({
                            value: currentValue,
                            onClick: (newV) => {
                                this.changeLayout({
                                    currentLine: index,
                                    oldLineDetail2: current,
                                    newLineDetailStr: newV,
                                    list: newList,
                                });
                            },
                        })}
                    <span className="cn-layout-setter-item-tip">{currentValue}</span>
                  </div>
                  {index === newList.length - 1 && !oneCodeMode && (<div className="cn-layout-setter-item-title" style={{ marginTop: '5px' }}>
                      <div className="cn-layout-setter-item-insert">
                        <CnBalloon v2 closable={false} align={'t'} popupStyle={{ minWidth: '312px' }} trigger={<CnButton size={'small'}>
                              {$i18n.get({ id: 'InsertNewLineAtEnd', dm: '末尾插入新行' })}
                            </CnButton>}>
                          <div className={'cn-layout-setter-item-content'}>
                            {makeColumnDom({
                                value: '',
                                onClick: (newV) => {
                                    this.insertNewBlock(current[current?.length - 1].index, newV.split(':'));
                                },
                            })}
                          </div>
                        </CnBalloon>
                      </div>
                      <div style={{ opacity: 0 }} className="cn-layout-setter-item-delete">
                        <CnButton size={'small'} warning>
                          {$i18n.get({ id: 'TERM.Delete', dm: '删除' })}
                        </CnButton>
                      </div>
                    </div>)}
                </div>);
                })
                : null}
      </div>);
    }
}
